// extracted by mini-css-extract-plugin
module.exports = {"nav":"JournalExecTickets_nav__2l3Zf","sticky":"JournalExecTickets_sticky__2pMw2"};